import { connect } from "react-redux";
import ThemMoiLoaiTaiSan from "components/CommonComponent/ThemMoiLoaiTaiSan";
import { postLoaiTaiSan, showModalLoaiTaiSan } from "actions/LoaiTaiSan";

const mapStateToProps = (state) => ({
  loaitaisan: state.loaitaisan,
  camdo: state.camdo,
});

const mapDispatchToProps = (dispatch) => ({
  postLoaiTaiSan: (dataPost) => dispatch(postLoaiTaiSan(dataPost)),
  showModalLoaiTaiSan: (dataPost) => dispatch(showModalLoaiTaiSan(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemMoiLoaiTaiSan);
